export default {
  template: require('./subscription-status.html'),
  windowClass: 'modal-sm',
  windowTemplateUrl: '/modals/default/modal-container.html',

  controller: ['$scope', '$timeout', '$location', 'key', 'object', function (
    $scope, $timeout, $location, key, object) {
    $scope.key = key;
    $scope.object = object;
    // $scope.referrer = referrer;

    $scope.upgrade = function () {
      // if ($rootScope.user.referredBy) {
      //   referralExperiment.track();
      // }
      $location.url('/account?tab=firm#plans');
    };
  }]
}



// WEBPACK FOOTER //
// ./project/modals/subscription-status/subscription-status.config.js